import { Col } from 'antd';
import styled, { css } from 'styled-components';

export const WidgetColumnWrapper = styled(Col)<{ width?: number }>`
  min-height: 0px;
  ${props =>
    props.width &&
    css`
      flex: 0 0 ${props.width}%;
      min-width: 0;
      width: ${props.width}%;
    `}
`;
